module.exports = __webpack_public_path__ + "static/media/frp1.055de36a.png";